import { render, staticRenderFns } from "./ShopUser.vue?vue&type=template&id=95ba56dc&scoped=true"
import script from "./ShopUser.vue?vue&type=script&lang=js"
export * from "./ShopUser.vue?vue&type=script&lang=js"
import style0 from "./ShopUser.vue?vue&type=style&index=0&id=95ba56dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ba56dc",
  null
  
)

export default component.exports